import React, { useState } from 'react';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';
import { db } from '../supabase/supabase';

const Newsletter = () => {
  const [email, setEmail] = useState('');
  const [status, setStatus] = useState('idle');

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!email) return;
    setStatus('loading');
    try {
      await db.newsletter.subscribe(email);
      setStatus('success');
      setEmail('');
    } catch (err) {
      console.error(err);
      setStatus('error');
    }
  };

  return (
    <div className="glass-card rounded-2xl p-8 md:p-12 relative overflow-hidden group">
      <div className="absolute top-0 right-0 w-64 h-64 bg-emerald-500/10 rounded-full blur-[80px] -mr-32 -mt-32 transition-all group-hover:bg-emerald-500/20"></div>
      
      <div className="relative z-10 max-w-2xl mx-auto text-center">
        <div className="inline-flex items-center justify-center w-12 h-12 rounded-full bg-slate-800 text-emerald-400 mb-6">
          <SafeIcon icon={FiIcons.FiMail} className="text-2xl" />
        </div>
        <h2 className="text-3xl font-bold text-white mb-4">Join the Journey</h2>
        <p className="text-slate-400 mb-8 max-w-xl mx-auto">
          Get behind-the-scenes dev logs on how I build and scale AI apps for underserved communities.
        </p>

        {status === 'success' ? (
          <div className="bg-emerald-500/10 border border-emerald-500/30 text-emerald-400 py-3 px-6 rounded-lg inline-flex items-center gap-2">
            <SafeIcon icon={FiIcons.FiCheckCircle} />
            <span>You're in! Check your inbox for the latest dev log.</span>
          </div>
        ) : (
          <form onSubmit={handleSubmit} className="flex flex-col sm:flex-row gap-3 max-w-md mx-auto">
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="your@email.com"
              className="flex-grow bg-slate-900/80 border border-slate-700 rounded-lg px-4 py-3 text-slate-200 focus:outline-none focus:border-emerald-500 focus:ring-1 focus:ring-emerald-500 transition-all placeholder:text-slate-600"
              required
            />
            <button 
              type="submit" 
              disabled={status === 'loading'}
              className="btn-primary whitespace-nowrap flex items-center justify-center gap-2 min-w-[120px]"
            >
              {status === 'loading' ? (
                <SafeIcon icon={FiIcons.FiLoader} className="animate-spin" />
              ) : (
                <>Join List <SafeIcon icon={FiIcons.FiSend} /></>
              )}
            </button>
          </form>
        )}
        {status === 'error' && <p className="text-red-400 mt-4 text-sm text-center">Something went wrong. Please try again.</p>}
      </div>
    </div>
  );
};

export default Newsletter;